










import { Component, Prop, Vue } from 'vue-property-decorator';
@Component({
  name: 'Button'
})
export default class extends Vue {
  @Prop({ default: '304' }) private width!: string;
  @Prop({ default: false }) private disabled!: Boolean;

  click() {
    if (!this.disabled) {
      this.$emit('click');
    }
  }
}
